var _circle, _circle2, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimizePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 60.9034,
    cy: 61.5206,
    r: 53.5206,
    fill: "#7551FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 60.906,
    cy: 61.5193,
    r: 60.0478,
    stroke: "#7551FF",
    strokeWidth: 1.29451
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_593_32602",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7193 44.7122C72.7193 38.5306 67.7082 33.5195 61.5267 33.5195C55.3451 33.5195 50.334 38.5306 50.334 44.7122C50.334 50.8937 55.3451 55.9048 61.5267 55.9048C67.7082 55.9048 72.7193 50.8937 72.7193 44.7122ZM37.1866 84.7203C38.9666 69.8243 48.9064 58.4217 60.9016 58.4217C72.8969 58.4217 82.8367 69.8243 84.6167 84.7203C84.9317 87.3564 82.7483 89.5167 80.0935 89.5167H41.7097C39.0549 89.5167 36.8716 87.3564 37.1866 84.7203Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1866 84.7203L34.2078 84.3644L37.1866 84.7203ZM84.6167 84.7203L87.5955 84.3644V84.3644L84.6167 84.7203ZM61.5267 36.5195C66.0513 36.5195 69.7193 40.1875 69.7193 44.7122H75.7193C75.7193 36.8738 69.365 30.5195 61.5267 30.5195V36.5195ZM53.334 44.7122C53.334 40.1875 57.002 36.5195 61.5267 36.5195V30.5195C53.6883 30.5195 47.334 36.8738 47.334 44.7122H53.334ZM61.5267 52.9048C57.002 52.9048 53.334 49.2368 53.334 44.7122H47.334C47.334 52.5505 53.6883 58.9048 61.5267 58.9048V52.9048ZM69.7193 44.7122C69.7193 49.2368 66.0513 52.9048 61.5267 52.9048V58.9048C69.365 58.9048 75.7193 52.5505 75.7193 44.7122H69.7193ZM60.9016 55.4217C46.8081 55.4217 36.0897 68.6155 34.2078 84.3644L40.1654 85.0763C41.8435 71.0332 51.0046 61.4217 60.9016 61.4217V55.4217ZM87.5955 84.3644C85.7136 68.6155 74.9951 55.4217 60.9016 55.4217V61.4217C70.7987 61.4217 79.9598 71.0332 81.6379 85.0763L87.5955 84.3644ZM80.0935 92.5167C84.2938 92.5167 88.1527 89.0274 87.5955 84.3644L81.6379 85.0763C81.681 85.437 81.5674 85.7568 81.309 86.0249C81.0354 86.3087 80.6052 86.5167 80.0935 86.5167V92.5167ZM41.7097 92.5167H80.0935V86.5167H41.7097V92.5167ZM34.2078 84.3644C33.6505 89.0274 37.5095 92.5167 41.7097 92.5167V86.5167C41.1981 86.5167 40.7679 86.3087 40.4943 86.0249C40.2358 85.7568 40.1223 85.437 40.1654 85.0763L34.2078 84.3644Z",
    fill: "#7551FF",
    mask: "url(#path-3-inside-1_593_32602)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6794 84.8985C40.4084 70.429 49.9589 59.9219 60.9051 59.9219C71.8512 59.9219 81.4017 70.429 83.1307 84.8985C83.3246 86.5211 81.979 88.0169 80.097 88.0169H41.7132C39.8311 88.0169 38.4855 86.5211 38.6794 84.8985Z",
    stroke: "#7551FF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizePerson);
export default __webpack_public_path__ + "static/media/OptimizePerson.b52766acefe50d91bdbd114efe050104.svg";
export { ForwardRef as ReactComponent };